import { GetUserPermissionsByRolesQuery, GetAuth0PermissionsQuery } from '@/__generated__/graphql';

export const getPermissionsWithRoles = (
  permissionsByRolesData: GetUserPermissionsByRolesQuery | undefined,
  allPermissionsData: GetAuth0PermissionsQuery['getAuth0Permissions'],
  selectedRole: string
) => {
  const permissionsMap = new Map();

  (permissionsByRolesData?.getUserPermissionsByRoles ?? []).forEach(
    ({ name: roleName, permissions }) => {
      permissions?.forEach((perm) => {
        if (perm?.name && perm?.description) {
          const { name, description } = perm;
          const permission = permissionsMap.get(name) || {
            name,
            description: description ?? 'N/A',
            roles: new Set(),
            count: 0,
          };

          permission.roles.add(roleName);
          permission.count++;

          if (roleName === selectedRole) {
            permission.roles = new Set([selectedRole]);
          }

          permissionsMap.set(name, permission);
        }
      });
    }
  );

  (allPermissionsData ?? []).forEach((perm) => {
    if (perm?.name && !permissionsMap.has(perm.name)) {
      const { name, description } = perm;
      permissionsMap.set(name, {
        name,
        description: description ?? 'N/A',
        roles: new Set(),
        count: 0,
      });
    }
  });

  return [...permissionsMap.values()]
    .filter(({ roles }) => roles.has(selectedRole))
    .map(({ roles, ...rest }) => ({
      ...rest,
      roles: [...roles],
    }));
};
